export default "__VITE_ASSET__Bl$YGbQb__"